// ** Redux
import { useSelector } from "react-redux";
import { getGallery } from "store/modules/main-pages/galleries/get-gallery.action";

// ** Custom Components
import Block from "components/layout/Block";
import ResultsDescription from "./components/ResultDescription";
import SharedGalleryFilters from "components/layout/SharedGalleryFilters";

// #####################################################

export const GalleryFiltersSection = ({ galleriesKey }) => {
	const filtersOpen = useSelector((state) => state.sharedFilters.isOpen);

	return (
		<Block flex column>
			<ResultsDescription />
			{filtersOpen && (
				<SharedGalleryFilters
					galleriesKey={galleriesKey}
					getGallery={getGallery}
				/>
			)}
		</Block>
	);
};

// #####################################################
